import RibbonButton from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { Indentation } from 'roosterjs-editor-types';
import { setIndentation } from 'roosterjs-editor-api';

const indent: RibbonButton = {
    key: 'indent',
    title: () => strings.indent,
    imageSrc: require('../svg/indent.svg'),
    imageRtlSrc: require('../svg/indent-rtl.svg'),
    onExecute: (plugin, logUsage) => {
        setIndentation(plugin.getEditor(), Indentation.Increase);
        logUsage('setIndentation', Indentation.Increase);
    },
};

export default indent;
